// extracted by mini-css-extract-plugin
module.exports = {"container":"_1Y1QQAY_N7kMBXxkbNSARj","msgType":"_1P5YbZ4eWDT7b0TxNbo2Qu","linkBtn":"_3-PMhRQqX8Yf17g92xUdEr"};